import RegionTools from 'utils/regions/regionTools'
import Colors from 'utils/colors/colors'

import messages from './messages'

let formatMessage = null

const importFormatter = importedFormatter => {
  formatMessage = importedFormatter
}

const rankData = ({ data, rankOrdering }) => {
  let orderedData = data.sort( (a, b) => b.value - a.value );
  if ( rankOrdering !== 'descending' ) {
    orderedData = orderedData.reverse();
  }
  return orderedData;
}

const firstComparableSet = ( data, regionIds, times, threshold, geo_key ) => {
  // serach for first set of annual values with at least threshold percentage of valid values
  let regionsData = data.filter( (d) => {
    return regionIds.indexOf( d[ geo_key ] ) >= 0;
  } );
  let min_n_values = regionIds.length * threshold;

  for (let time of times) {
    let values = regionsData.filter( d => {
      return (d["time"] === time) & (d["value"] != null)
    } );

    if ( values.length >= min_n_values ) {
      return values;
    }
  }

  return null;
}


const formatRankingSeries = ({ data, regionsData, selectedRegionId, comparativeData, color, rankOrdering }) => {
  let orderedData = orderRankingData({ data, regionsData, rankOrdering })
  let series = []
  let selectedRegionSerie
  let comparativeSerie
  let totalRegions = orderedData.length
  let comparativeRegionId
  if (comparativeData !== null && !comparativeData.isCountry) {
    comparativeRegionId = Number(comparativeData.data.query.geo[0])
  }

  orderedData.forEach((item, index) => {
    let serie
    if (Number(item.id) === selectedRegionId) {
      selectedRegionSerie = formatRankingForSelectedRegion({
        name: item.name,
        index,
        totalRegions,
        value: item.value,
        color
      })
    } else if (comparativeRegionId && Number(item.id) === comparativeRegionId) {
      comparativeSerie = formatRankingForComparativeWithRegion({
        name: item.name,
        index,
        totalRegions,
        value: item.value,
        color
      })
    } else {
      serie = formatRankingForOtherRegions({
        name: item.name,
        index,
        totalRegions,
        value: item.value
      })
      series.push(serie)
    }
  })

  if (comparativeData !== null && comparativeData.isCountry) {
    comparativeSerie = formatRankingForComparativeWithCountry({
      name: comparativeData.countryFullName,
      value: comparativeData.data.data[0].value,
      color
    })
  }

  if (comparativeData !== null && comparativeSerie) series.push(comparativeSerie)
  if (selectedRegionSerie) series.push(selectedRegionSerie)

  return series
}

const orderRankingData = ({ data, regionsData, rankOrdering }) => {
  let usefulData = data.data.map(item => ({
    name: RegionTools.getRegionNameFromId({
      id: data.query.geo[item.geoset],
      regionsData
    }),
    id: data.query.geo[item.geoset],
    value: item.value
  }))
  let orderedData = usefulData.sort((a, b) => b.value - a.value)
  if (rankOrdering !== 'descending') orderedData = orderedData.reverse()
  return orderedData
}

const formatRankingForSelectedRegion = ({ name, index, totalRegions, value, color }) => {
  return {
    name: `${name}`,
    marker: {
      radius: 13,
      fillColor: Colors.colorToRGBA(color),
      lineColor: Colors.colorToRGBA(color),
      lineWidth: 2
    },
    data: [
      {
        name: formatMessage(messages.rankingTooltip, { position: index + 1, totalRegions }),
        x: value,
        y: 0
      }
    ]
  }
}

const formatRankingForComparativeWithCountry = ({ name, value, color }) => {
  return {
    name: `${name}`,
    marker: {
      radius: 13,
      fillColor: '#FFFFFF',
      lineColor: Colors.colorToRGBA(color, 1),
      lineWidth: 2
    },
    data: [
      {
        name: '',
        x: value,
        y: 0
      }
    ]
  }
}
const formatRankingForComparativeWithRegion = ({ name, index, totalRegions, value, color }) => {
  return {
    name: `${name}`,
    marker: {
      radius: 13,
      fillColor: '#FFFFFF',
      lineColor: Colors.colorToRGBA(color, 1),
      lineWidth: 2
    },
    data: [
      {
        name: formatMessage(messages.rankingTooltip, { position: index + 1, totalRegions }),
        x: value,
        y: 0
      }
    ]
  }
}

const formatRankingForOtherRegions = ({ name, index, totalRegions, value }) => {
  return {
    name: `${name}`,
    data: [
      {
        name: formatMessage(messages.rankingTooltip, { position: index + 1, totalRegions }),
        x: value,
        y: 0
      }
    ]
  }
}

const panelRowValuesAdapter = {
  formatRankingSeries,
  importFormatter,
  firstComparableSet,
  rankData
}
export default panelRowValuesAdapter



// WEBPACK FOOTER //
// ./src/modules/Charts/PanelRow/PanelRowValues/PanelRowValuesAdapter.js